import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/r/$code')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/subscribe/landing',
      search: { referral_code: params.code },
    })
  },
})
